import script from "./hotel.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel.vue?vue&type=script&setup=true&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=7736c387&lang=scss&scoped=true"
import "./hotel.vue?vue&type=style&index=1&id=7736c387&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7736c387"]])

export default __exports__